import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Receipt } from "lucide-react";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Header } from "@/components/Header";
import { SportsSidebar } from "@/components/SportsSidebar";
import { BetSlip } from "@/components/BetSlip";
import { AuthDialog } from "@/components/AuthDialog";
import { useSlip } from "@/context/BetSlipContext";
import { WinsTicker } from "@/components/WinsTicker";

export default function Layout() {
  const [menu, setMenu] = useState(false);
  const { items, open, setOpen } = useSlip();
  return (
    <div className="min-h-screen bg-[#0B0E14]">
      <Header onMenu={() => setMenu(true)} />
      <div className="flex">
        <aside className="scroll-thin sticky top-14 hidden h-[calc(100vh-3.5rem)] w-60 shrink-0 overflow-y-auto border-r border-[#1E293B] bg-[#0E131F] lg:block">
          <SportsSidebar />
        </aside>
        <main className="min-w-0 flex-1 px-3 pb-28 pt-4 sm:px-6">
          <WinsTicker />
          <Outlet />
          <footer className="mt-12 border-t border-[#1E293B] pt-6 text-xs leading-relaxed text-slate-500">
            18+ only. Gamble responsibly. betterPlay — live fixtures, scores and results from ESPN public data; odds from DraftKings via ESPN
            where available, otherwise house-priced. Virtual horse racing, Lucky Numbers and Fly High are settled by the betterPlay random
            number generator (Lucky Numbers draws run at each lottery's official draw time). Betting is subject to local laws in your country.
          </footer>
        </main>
        <aside className="sticky top-14 hidden h-[calc(100vh-3.5rem)] w-80 shrink-0 border-l border-[#1E293B] bg-[#121824] xl:block">
          <BetSlip />
        </aside>
      </div>

      <button
        data-testid="mobile-betslip-button"
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-4 z-40 flex items-center gap-2 rounded-full bg-[#F59E0B] px-4 py-3 font-display font-black uppercase text-[#0B0E14] shadow-lg xl:hidden"
      >
        <Receipt className="h-4 w-4" /> Slip ({items.length})
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full max-w-sm border-[#1E293B] bg-[#121824] p-0">
          <BetSlip />
        </SheetContent>
      </Sheet>
      <Sheet open={menu} onOpenChange={setMenu}>
        <SheetContent side="left" className="w-64 border-[#1E293B] bg-[#0E131F] p-0">
          <SportsSidebar onNavigate={() => setMenu(false)} />
        </SheetContent>
      </Sheet>
      <AuthDialog />
    </div>
  );
}
